/**
 * Utility functions for Amplitude Analytics
 */ import { CheggEnv, getCheggEnv } from '@chegg/utils';
// =============================================================================
// CONSTANTS
// =============================================================================
export const APP_VERSION = '1.0.0';
// =============================================================================
// COOKIE UTILITIES
// =============================================================================
/**
 * Get cookie value by name
 */ export function getCookie(name) {
    if (typeof document === 'undefined') {
        return null;
    }
    const cookieString = document.cookie;
    const cookies = cookieString.split('; ');
    for (const cookie of cookies){
        const [cookieName, cookieValue] = cookie.split('=');
        if (cookieName === name) {
            return cookieValue || null;
        }
    }
    return null;
}
// =============================================================================
// AUTHENTICATION UTILITIES
// =============================================================================
/**
 * Check if user is hard logged in by looking for authentication indicators
 */ export function isHardLoggedIn() {
    if (typeof document === 'undefined' || typeof localStorage === 'undefined') {
        return false;
    }
    return document.cookie.includes('id_token=') || document.cookie.includes('auth_token=') || localStorage.getItem('isAuthenticated') === 'true';
}
// =============================================================================
// CONFIGURATION UTILITIES
// =============================================================================
/**
 * Get the appropriate Amplitude API key based on the environment
 */ export function getAmplitudeApiKey() {
    return getCheggEnv() === CheggEnv.PROD ? 'b187e8b9918b00d161ce03017d355298' // production
     : '1932b4101d16be26ecd33bb9cf543b03'; // non-production
}
